import React from "react";
import PropTypes from "prop-types";
import FaDownload from "react-icons/fa/download";
import { attachmentType } from "custom-prop-types";
import { isValidValue } from "utils/validators";

export const DownloadUrlCellFormatter = ({ value }) => {
  if (!isValidValue(value)) {
    return <span />;
  }
  return (
    <a href={ value.url || value } rel="noopener noreferrer" tabIndex={ -1 } target="_blank">
      <FaDownload size={ 20 } />
    </a>
  );
};

DownloadUrlCellFormatter.defaultProps = {
  value: null
};

DownloadUrlCellFormatter.propTypes = {
  value: PropTypes.oneOfType([
    attachmentType,
    PropTypes.string
  ])
};



// WEBPACK FOOTER //
// ./src/js/components/grid/cell-formatters/download-url-cell-formatter.jsx